<template>
  <div>
    <div class="grid-view">
      <div class="main-content booking-channel-config">
        <div class="app-main-inner-row">
          <div class="filters">
            <el-form :inline="true" label-width="60px" label-position="left" @submit.native.prevent>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')" class="el-form-item-w400">
                  <cargo-advance-select
                    no="searchBranchId"
                    :select-type="selectTypeNames.basic_data_Office"
                    :multiple="true"
                    :clearable="true"
                    filterable
                    :default-multiple-value="searchConditions.branchId"
                    tag-value="officeId"
                    tag-name="code"
                    :filter-tag-names="['englishName','chineseName','code']"
                    :cache="false"
                    :static-options="officeList"
                    :placeholder="' '"
                    @parentCallBack="p=>{searchConditions.branchId=p.value;}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_CarrierShip')" class="el-form-item-w540">
                  <cargo-advance-select
                    no="searchCarrierId"
                    :select-type="selectTypeNames.basic_data_Company"
                    :multiple="true"
                    :clearable="true"
                    filterable
                    :default-multiple-value="searchConditions.carrierId"
                    :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                    callback-method-type="value"
                    :callback-params="{key:'carrierId'}"
                    :placeholder="' '"
                    @parentCallBack="p=>{searchConditions.carrierId=p.value;}"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="triggers">
            <el-button type="primary" size="mini" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
            <el-button type="primary" size="mini" @click="popMappingAddDialog">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" size="mini" @click="popMappingEditFormDialog">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" size="mini" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-options="gridOptions"
            :side-bar="sideBarDefs"
            style="width: 100%;"
          />
        </div>
        <div>
          <cargo-pagination
            config-module="260311"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchData"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowDialogForm"
      :title="dialogTitle"
      width="400px"
      custom-class="booking-channel-config-dialog"
    >
      <div class="details-view">
        <div class="main-content">
          <el-form ref="mappingForm" :model="mappingForm" label-width="100px" label-position="right">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_OperationOffice')" class="el-form-item-w320">
                <cargo-advance-select
                  no="branchId"
                  :select-type="selectTypeNames.basic_data_Office"
                  :multiple="true"
                  :clearable="false"
                  filterable
                  :default-multiple-value="mappingForm.branchIdList"
                  tag-value="officeId"
                  tag-name="code"
                  :filter-tag-names="['englishName','chineseName','code']"
                  :cache="false"
                  :static-options="officeList"
                  :placeholder="' '"
                  @parentCallBack="p=>{mappingForm.branchIdList=p.value;}"
                />
              </el-form-item>
              <el-form-item class="el-form-item-w320">
                <span slot="label" class="blue">{{ $t('SeaExport.ShippingCompany') }}</span>
                <cargo-company-select
                  no="carrierId"
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  :default-value="mappingForm.carrierId||''"
                  @change="p=>{mappingForm.carrierId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.BookingAgent')" class="el-form-item-w320">
                <cargo-advance-select
                  no="bookingAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
                  :default-value="mappingForm.bookingAgent||''"
                  @parentCallBack="p=>{mappingForm.bookingAgent=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CarrierAgent')" class="el-form-item-w320">
                <cargo-company-select
                  no="carrierAgentId"
                  :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
                  :default-value="mappingForm.carrierAgentId||''"
                  @change="p=>{mappingForm.carrierAgentId=p.value}"
                />
              </el-form-item>
              <el-form-item class="el-form-item-w320">
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_BookingMode') }}</span>
                <el-radio-group v-model="mappingForm.bookingMode" no="bookingMode">
                  <el-radio v-for="item in BOOKING_MODES" :key="item.code" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_RpaSupplier')" class="el-form-item-w320">
                <el-select v-model="mappingForm.rpaSupplier" no="rpaSupplier">
                  <el-option v-for="item in RPA_SUPPLIERS" :key="item.code" :label="isZh ? item.chineseName : item.englishName" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BookingChannel')" class="el-form-item-w320">
                <el-select v-model="mappingForm.bookingChannel" no="bookingChannel" clearable>
                  <el-option v-for="item in BOOKING_CHANNELS" :key="item.code" :label="isZh ? item.chineseName : item.englishName" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')" class="el-form-item-w320">
                <el-input v-model="mappingForm.authUser" no="authUser" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_Password')" class="el-form-item-w320">
                <el-input v-model="mappingForm.authPassword" no="authPassword" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_WebSite')" class="el-form-item-w320">
                <el-input v-model="mappingForm.webSite" no="webSite" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CompanyCode')" class="el-form-item-w320">
                <el-input v-model="mappingForm.companyCode" no="companyCode" />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ReceiptConfig') }}</span>
                <el-radio-group v-model="mappingForm.receiptConfig" no="receiptConfig">
                  <el-radio v-for="item in RECEIPT_CONFIGS" :key="item.code" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submit">{{ $t('common.btn.ok') }}</el-button>
        <el-button size="mini " @click="isShowDialogForm=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import { getBookingChannelConfigList, saveBookingChannelConfig, delBookingChannelConfig } from '@/api/sysManage/baseConfig/bookingChannelConfig'
import { Assert } from '@/utils/validate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { deepClone } from '@/utils'
import * as commonUtil from '@/utils/commonUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BookingChannelConfig',
  components: { cargoCompanySelect, cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BranchCMP'), field: 'branchIds', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return ColumnUtils.branchIdsLabelFunction(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        { headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
          }
        },
        { headerName: this.$t('SeaExport.BookingAgent'), field: 'bookingAgent', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          }
        },
        { headerName: this.$t('SeaExport.CarrierAgent'), field: 'carrierAgentId', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingChannel'), field: 'bookingChannel', initialWidth: 120, minWidth: 120,
          cellRenderer: params => {
            return ColumnUtils.BookingChannelLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingMode'), field: 'bookingMode', initialWidth: 120, minWidth: 120,
          cellRenderer: params => {
            return ColumnUtils.BookingModeLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountNumber'), field: 'authUser', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Password'), field: 'authPassword', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_WebSite'), field: 'webSite', initialWidth: 160, minWidth: 160 },
        { headerName: this.$t('CargoMsg.Cargo_CompanyCode'), field: 'companyCode', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_ReceiptConfig'), field: 'receiptConfig', initialWidth: 140, minWidth: 140,
          cellRenderer: params => {
            return ColumnUtils.ReceiptConfigLabelFun(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      gridApi: null,
      searchConditions: {
        carrierId: [], // 船公司
        branchId: [], // 分公司
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      initMappingForm: {
      },
      mappingForm: {
        uuid: '',
        branchIds: '', // 分公司ID
        branchIdList: [], // 分公司ID
        carrierId: 0, // 船公司
        bookingAgent: 0, // 订舱代理
        carrierAgentId: 0, // 船代
        bookingMode: 1, // 订舱模式
        rpaSupplier: 'YD', // RPA供应商
        bookingChannel: '', // 订舱渠道
        authUser: '', // 账号
        authPassword: '', // 密码
        webSite: '', // 网址
        companyCode: '', // 公司编码
        receiptConfig: 0 // 回执配置
      },
      isShowDialogForm: false,
      officeList: [], // 分公司列表
      BOOKING_MODES: SystemConstants.BOOKING_MODES,
      RPA_SUPPLIERS: SystemConstants.RPA_SUPPLIERS,
      BOOKING_CHANNELS: SystemConstants.BOOKING_CHANNELS,
      RECEIPT_CONFIGS: SystemConstants.RECEIPT_CONFIGS
    }
  },
  computed: {
    url() {
      return URL
    },
    dialogTitle() {
      if (this.mappingForm.uuid) {
        return this.$t('CargoMsg.Cargo_EditBookingChannelConfig')
      }
      return this.$t('CargoMsg.Cargo_AddBookingChannelConfig')
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initMappingForm = { ...this.mappingForm }
    // 分公司列表
    this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
    this.officeList = this.officeList.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId - office2.officeId)
  },
  mounted() {
    this.toQuery()
  },
  methods: {
    toQuery() {
      this.searchConditions.pageNum = 1
      this.searchConditions.total = 0
      this.fetchData()
    },
    fetchData() {
      this.loading = getLoading()
      const params = { ...this.searchConditions }
      getBookingChannelConfigList(params).then((res) => {
        this.rowData = res.data.list
        this.searchConditions.total = res.data.total ? Number(res.data.total) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    popMappingAddDialog() {
      this.isShowDialogForm = true
      this.mappingForm = { ...this.initMappingForm }
    },
    async popMappingEditFormDialog() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      this.mappingForm = deepClone(rows[0])
      console.log('this.mappingForm', this.mappingForm)
      // 分公司
      this.mappingForm.branchIdList = commonUtil.split(this.mappingForm.branchIds, ',', true)
      // 显示编辑弹窗
      this.isShowDialogForm = true
    },
    async toBatchDel() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      await this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), { type: 'warning' })
      this.loading = getLoading()
      delBookingChannelConfig([rows[0].uuid]).then(async() => {
        await this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 检查
    async toCheckForm() {
      await Assert.isTrue(this.mappingForm.carrierId, this.$t('SeaExport.shippingCompanyCannotBeEmpty'), 'warning')
      await Assert.isTrue(this.mappingForm.receiptConfig, this.$t('CargoMsg.Cargo_ReceiptConfigCannotBeEmpty'), 'warning')
    },
    async submit() {
      this.mappingForm.carrierId = this.mappingForm.carrierId || 0
      this.mappingForm.bookingAgent = this.mappingForm.bookingAgent || 0
      this.mappingForm.carrierAgentId = this.mappingForm.carrierAgentId || 0
      // 分公司
      if (this.mappingForm.branchIdList) {
        let text = ''
        for (const data of this.mappingForm.branchIdList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.mappingForm.branchIds = text
      } else {
        this.mappingForm.branchIds = ''
      }
      await this.toCheckForm()
      if (this.mappingForm.uuid) {
        await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmSaveModifiedInfo'), this.$t('common.tips.confirm'), { type: 'warning' })
      }
      this.loading = getLoading()
      saveBookingChannelConfig(this.mappingForm).then(async() => {
        this.isShowDialogForm = false
        this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.booking-channel-config {
  .el-form-item-w400 {
    width: 400px;
    margin-right: 20px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 340px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w540 {
    width: 540px;
    margin-right: 20px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 480px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
}
.booking-channel-config-dialog {
  .el-dialog__body {
    font-size: 12px;
    padding: 10px;
    min-height: 440px;
  }
  .el-form-item-w320 {
    width: 320px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 220px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
}
</style>
